const parseEvSensorData = (envData, allDates, Ev_list) => {
  const seqData = {};
  const rows = Array.isArray(envData) ? envData : envData?.data || [];

  rows.forEach(item => {
    if (!seqData[item.seq]) seqData[item.seq] = [];
    seqData[item.seq].push(item);
  });

  const horizontalIrradiance = new Array(allDates.length).fill(null);
  const tiltedIrradiance = new Array(allDates.length).fill(null);
  const surfaceTemp = new Array(allDates.length).fill(null);
  const outdoorTemp = new Array(allDates.length).fill(null);

  const seqs = Ev_list.seq || [];
  const sunTypes = Ev_list.ev_sunType || [];
  const tempTypes = Ev_list.ev_temperatureType || [];

  allDates.forEach((label, labelIndex) => {
    seqs.forEach((seq, index) => {
      const dataArray = seqData[seq];
      if (!dataArray) return;

      const filtered = dataArray.filter(item => item.created_at.split(' ')[0] === label);
      if (!filtered.length) return;

      const avg = arr => arr.reduce((a, b) => a + b, 0) / arr.length;
      const sunType = sunTypes[index];
      const tempType = tempTypes[index];

      const suns = filtered.map(d => d.sun);
      const temps = filtered.map(d => d.temperature / 10);

      if (sunType === 0 && horizontalIrradiance[labelIndex] === null) {
        horizontalIrradiance[labelIndex] = avg(suns);
      }
      if (sunType === 1 && tiltedIrradiance[labelIndex] === null) {
        tiltedIrradiance[labelIndex] = avg(suns);
      }

      if (tempType === 0 && surfaceTemp[labelIndex] === null) {
        surfaceTemp[labelIndex] = avg(temps);
      }
      if (tempType === 1 && outdoorTemp[labelIndex] === null) {
        outdoorTemp[labelIndex] = avg(temps);
      }
    });
  });

  return {
    horizontalIrradiance,
    tiltedIrradiance,
    surfaceTemp,
    outdoorTemp
  };
};
export { parseEvSensorData, parseEvSensorData as processEvSensorData };
